import * as components from './src/index'
export default components
